import { render, staticRenderFns } from "./theatreDetailForLook.vue?vue&type=template&id=36fc3296&scoped=true&"
import script from "./theatreDetailForLook.vue?vue&type=script&lang=js&"
export * from "./theatreDetailForLook.vue?vue&type=script&lang=js&"
import style0 from "./theatreDetailForLook.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./theatreDetailForLook.vue?vue&type=style&index=1&id=36fc3296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc3296",
  null
  
)

export default component.exports